import React from "react";
import { Container, Eyebrow, RevealHeading, PillButton, Reveal } from "@/components/primitives";

export const CTASection = ({
  eyebrow = "Start a Conversation",
  title = ["Have a problem", "that needs to move?"],
  copy,
  cta = "Start the Conversation",
  ctaTo = "/contact",
}) => (
  <section className="relative overflow-hidden bg-govx-green text-white" data-testid="cta-section">
    <Container className="relative z-10 py-20 lg:py-28">
      <Eyebrow dark>{eyebrow}</Eyebrow>
      <RevealHeading
        lines={Array.isArray(title) ? title : [title]}
        className="mt-6 max-w-3xl font-display text-3xl font-medium leading-[1.05] tracking-tight sm:text-5xl"
      />
      {copy && (
        <Reveal delay={0.15}>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/85 sm:text-lg">{copy}</p>
        </Reveal>
      )}
      <Reveal delay={0.25}>
        <PillButton
          to={ctaTo}
          variant="outline"
          dark
          className="mt-9 border-white/40 text-white hover:border-white hover:text-white"
          data-testid="cta-section-button"
        >
          {cta}
        </PillButton>
      </Reveal>
    </Container>
    <div className="pointer-events-none absolute -right-20 top-1/2 h-[420px] w-[420px] -translate-y-1/2 rounded-full border border-white/15" />
    <div className="pointer-events-none absolute -right-10 top-1/2 h-[280px] w-[280px] -translate-y-1/2 rounded-full border border-white/15" />
  </section>
);
